// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OzKU","newExpiryDate":"styles_newExpiryDate__1FNXM","footer":"styles_footer__3SGB3"};